export class BookingBookModel {
    nameId: string;
    mode: string;
    bookRemarks: string;
    farmAndFieldValue:string;
    signatureImage: string;
    isByPhone: boolean;
    bookingProgram:string;
    otherNumber:string;
    constructor() {
        this.nameId = '';
        this.bookRemarks = '';
        this.signatureImage = '';
        this.mode = '';
        this.isByPhone = false;
        this.bookingProgram = "";
        this.otherNumber ="";
    }
}